import { useMemo, useState } from "react";
import styles from "./TabbedResourceBrowser.module.css";
import ResourceTile from "../ResourceTile/ResourceTile";
import ResourceBrowserSearchResults from "../ResourceBrowserSearchResults/ResourceBrowserSearchResults";
import ResourceBrowserTabsContainer from "../ResourceBrowserTabsContainer/ResourceBrowserTabsContainer";

function TabbedResourceBrowser({ data = {} }) {
    const [activeTab, setActiveTab] = useState(Object.keys(data)[0] ?? "");
    const searchActive = useMemo(() => activeTab === "Search", [activeTab]);
    const [searchValue, setSearchValue] = useState("");

    const filteredSearchResults = useMemo(
        () =>
            Object.values(data)
                .flat()
                .filter((v) => {
                    const category = v.href
                        .split("/")
                        .at(-2)
                        .replace(/-/g, " ");

                    return (
                        `${category} ${v.name} ${v.href}`
                            .toLowerCase()
                            .includes(searchValue.toLowerCase()) &&
                        searchValue !== ""
                    );
                }),
        [data, searchValue]
    );

    return (
        <div className={styles.main_container}>
            <ResourceBrowserTabsContainer
                activeTab={activeTab}
                setActiveTab={setActiveTab}
                tabs={Object.keys(data)}
                setSearchValue={setSearchValue}
                searchActive={searchActive}
            />
            <div className={styles.bottom_container}>
                {filteredSearchResults.length > 0 && searchActive && (
                    <div className={styles.results_count}>
                        Found {filteredSearchResults.length} results for{" "}
                        <span style={{ color: "var(--keel-orange)" }}>
                            {searchValue}
                        </span>
                    </div>
                )}
                <div
                    className={[
                        styles.results_container,
                        !searchActive ? styles.grid : "",
                    ].join(" ")}
                >
                    {searchActive ? (
                        <ResourceBrowserSearchResults
                            results={filteredSearchResults}
                            searchValue={searchValue}
                        />
                    ) : (
                        data[activeTab].map((result) => (
                            <ResourceTile {...result} key={result.name} />
                        ))
                    )}
                </div>
            </div>
        </div>
    );
}

export default TabbedResourceBrowser;
